export default __webpack_public_path__ + "static/media/bg3.4420365c.jpg";